import type { PropsWithChildren } from 'react';

import { twMerge } from 'tailwind-merge';

export function PageHeaderContainer({ children, className }: PropsWithChildren<{ className?: string }>) {
  return (
    <div
      className={twMerge(
        'flex flex-1 flex-col items-center justify-center gap-1 py-px md:flex-row md:gap-3',
        className
      )}
    >
      {children}
    </div>
  );
}
